module.exports = __webpack_public_path__ + "static/media/acoe_logo.ea4ab3ff.png";